import React from 'react';
import { Scissors, Brush, Droplet } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Cortes de cabello',
    description: 'Cortes clásicos y modernos, adaptados a tu estilo personal con precisión y detalle.',
    icon: <Scissors className="w-10 h-10 text-gold mb-4" data-id="element-83" />
  }, {
    title: 'Arreglo de barba',
    description: 'Perfilado, recorte y cuidado integral de tu barba para un look impecable.',
    icon: <Brush className="w-10 h-10 text-gold mb-4" data-id="element-84" />
  }, {
    title: 'Afeitado clásico',
    description: 'Experiencia tradicional con toalla caliente y navaja para un acabado perfecto.',
    icon: <Droplet className="w-10 h-10 text-gold mb-4" data-id="element-85" />
  }];
  return <section className="w-full py-20 px-4 bg-background" data-id="element-86">
      <div className="max-w-6xl mx-auto" data-id="element-87">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-center mb-16 uppercase tracking-wide" data-id="element-88">
          Nuestros <span className="text-gold" data-id="element-89">Servicios</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-90">
          {services.map((service, index) => <div key={index} className="border border-gold bg-[#111111] p-8 rounded-lg flex flex-col items-center text-center" data-id="element-91">
              {service.icon}
              <h3 className="font-display text-2xl font-bold mb-4 uppercase" data-id="element-92">
                {service.title}
              </h3>
              <p className="text-muted" data-id="element-93">{service.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}